import { Component, input, InputSignal } from '@angular/core';

@Component({
  selector: 'bizz-execute-checklist-question-preview',
  standalone: true,
  imports: [],
  templateUrl: './execute-checklist-question-preview.component.html',
  styleUrl: './execute-checklist-question-preview.component.scss'
})
export class ExecuteChecklistQuestionPreviewComponent {

  public loading: InputSignal<boolean> = input<boolean>(false);
}
